<script setup lang="ts">
import { User, UserGoal } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersMutations, UsersState } from '@/stores/users.store';
import { computed, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState & { us: UsersState }>();
const goals = computed<UserGoal[]>(() => store.state.us.userGoals);
const loaded = ref<boolean>(false);

const props = defineProps({
  user: {
    type: Object as PropType<User>,
    required: true,
  },
});

function loadGoals() {
  store.dispatch(UsersActions.GetGoals, props.user.id);
  loaded.value = true;
}

function deleteUserGoal(id: number) {
  if (
    confirm(
      'This will delete the user goal, and all the items associated with it',
    )
  ) {
    store.dispatch(UsersActions.DeleteUserGoal, {
      id,
      userId: props.user.id,
    });
  }
}

watch(
  () => props.user,
  () => {
    store.commit(UsersMutations.SetGoals, []);
    loaded.value = false;
  },
);

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Text', key: 'goal.title', width: '65%' },
  { title: 'Main', key: 'main', width: '10%' },
  { title: 'Options', key: 'options', width: '20%' },
];
</script>
<template>
  <v-card class="mt-4" v-if="user.id !== -1">
    <v-card-title>Goals</v-card-title>
    <v-card-text v-if="!goals.length && !loaded">
      <v-btn @click="loadGoals" color="info" density="compact"
        >See user goals</v-btn
      >
    </v-card-text>
    <v-card-text v-else>
      <v-data-table :items="goals" :headers="headers">
        <template v-slot:item.main="{ value }">
          {{ value ? 'Yes' : 'No' }}
        </template>
        <template v-slot:item.options="{ item }">
          <v-btn
            density="compact"
            icon="mdi-delete-outline"
            :disabled="item.main"
            @click="deleteUserGoal(item.goal.id)"
          />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
